import { atom } from 'jotai';

import type { RecordingEntry } from './types';

export const recordingsAtom = atom<readonly RecordingEntry[]>([]);
